import { createSelector } from '@reduxjs/toolkit';
import { selectHasRamp } from 'shared/selectors/jsonQuery';

export const selectHasRampFilter = createSelector(selectHasRamp, value => ({
  label: 'Есть пандус',
  value: Boolean(value),
}));
